<template lang="pug">
  app-dialog(v-model="$_show" :header="'Редактирование профиля судьи'" @confirm="updateJudge()" confirmText="Сохранить" width="800")
    v-layout.mt-1
      v-flex(xs6)
        app-card-title ФИО судьи
        app-text-field(v-model="currentJudge.firstName" label="Имя") 
        app-text-field(v-model="currentJudge.middleName" label="Отчество")
        app-text-field(v-model="currentJudge.lastName" label="Фамилия")
        v-layout.mt-1
          v-flex(xs8)
            app-date-picker(v-model="currentJudge.startDate" viewFormat="DD.MM.YYYY" label="Дата начала работы") 
          v-flex.ml-2(xs4)
            app-text-field(v-model="currentJudge.hall" label="№ зала")
        app-select(v-model="currentJudge.caseTypes" :items="caseTypes" label="Тип рассматриваемых дел" item-text="title" multiple return-object)
      v-flex.ml-10(xs6)
        app-card-title Контактная информация
        app-text-field(v-model="currentJudge.phone" label="Телефон")
        app-text-field(v-model="currentJudge.email" label="E-mail")
        app-text-field(v-model="currentJudge.fax" label="Факс")
        app-text-field(v-model="currentJudge.secretary" label="ФИО Секретаря")
        app-select(v-model="currentJudge.court" :items="courts" label="Наименование суда" item-text="name" return-object)
        v-switch(v-model="currentJudge.butterflynet" label="Исключить из распределения")
        app-text-field(v-model="currentJudge.lazySlave" label="Нагрузка дел в %"
          :rules="[rules.number]"
          append-outer-icon="add"     @click:append-outer="incrementWeight"
          prepend-outer-icon="remove" @click:prepend-outer="decrementWeight"
        )
    v-layout
      v-flex(xs6)
        app-card-title Добавить подпись
        v-btn.mx-0.mt-6(@click="$refs.localfile.click()") Выберите файл
          v-icon(right dark) attach_file
        input(id="sud-upload-sign-id" type="file" style="display: none" ref="localfile" @change="changeFile")
        
      v-flex.ml-10(xs6)
        div(v-if="sign")
          img(:src="'data:image/jpg;base64,' + sign" width="350px")     
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService, docService } from "@/_services";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [AppDialogToggable, $_validate_rules],

  props: {
    signBase64: String
  },

  watch: {
    signBase64 (obj) {
      this.sign = obj ? obj : ''
    }
  },

  mounted () {
    this.$store.dispatch('court/INIT')
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapState('court', ['courts']),
    ...mapGetters('judgeReestr', ['caseTypes']),
  },
  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    incrementWeight () {
      this.currentJudge.lazySlave =  this.currentJudge.lazySlave*1 + 1
    },

    decrementWeight () {
       this.currentJudge.lazySlave =  this.currentJudge.lazySlave*1 - 1 
    },
    
    updateJudge () {
      this.currentJudge.signImage = ''
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
      return true
    },

    changeFile () {
      let input = document.getElementById('sud-upload-sign-id')
      this.currentJudge.signImage = input.files[0].name
      this.uploadFile()
    },

    uploadFile () {
      var formData = new FormData();
      var imagefile = document.getElementById('sud-upload-sign-id')
      formData.append("file", imagefile.files[0])

      docService.uploadRfiles(formData)
      .then(data => {
        this.currentJudge.signImage = data
        judgeService.updateJudge(this.currentJudge).then(() => this.getSign())
      })
    },

    getSign () {
      judgeService.getSign(this.currentJudge).then(data => this.sign = data )
    },
  },

  data () {
    return {
      sign: ''
    }
  }
}
</script>